import React, { useState, useEffect } from 'react';
import { Moon, Sun } from 'lucide-react';

export default function DarkModeToggle({ className = '' }) {
  const [dark, setDark] = useState(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('rendplex-theme');
      if (saved) return saved === 'dark';
      return window.matchMedia('(prefers-color-scheme: dark)').matches;
    }
    return false;
  });

  useEffect(() => {
    const root = document.documentElement;
    if (dark) {
      root.classList.add('dark');
      localStorage.setItem('rendplex-theme', 'dark');
    } else {
      root.classList.remove('dark');
      localStorage.setItem('rendplex-theme', 'light');
    }
  }, [dark]);

  return (
    <button
      data-testid="dark-mode-toggle"
      onClick={() => setDark(prev => !prev)}
      className={`relative w-9 h-9 rounded-xl flex items-center justify-center transition-colors duration-300 
        ${dark 
          ? 'bg-slate-800 hover:bg-slate-700 text-[#45C04A]' 
          : 'bg-slate-100 hover:bg-slate-200 text-[#12355B]'
        } ${className}`}
      aria-label={dark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {dark ? (
        <Sun className="w-4 h-4 transition-transform duration-300" />
      ) : (
        <Moon className="w-4 h-4 transition-transform duration-300" />
      )}
    </button>
  );
}
